export const galleryImages = [
  // Fleet Operations - Large Scale
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_0b1e91d0-9c1d-440a-9b84-aeb555888e53/artifacts/770c8gbd_10-Feed-D_Soto-Febrero-2026.jpg",
    category: "Fleet Operations",
    title: "Large-Volume Execution",
    description: "Structured operations designed for high-capacity airport and hospitality environments"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_0b1e91d0-9c1d-440a-9b84-aeb555888e53/artifacts/p53cw3vl_5-Feed-D_Soto-Febrero-2026.jpg",
    category: "Fleet Operations",
    title: "Airport Parking Infrastructure",
    description: "Industrial-scale fleet maintenance at major transportation hubs"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/fzyt1e47_4.jpg",
    category: "Fleet Operations",
    title: "Structured Parking Operations",
    description: "Enterprise-level fleet logistics and facility management"
  },
  // Team & Workforce
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/z8l1mlej_2.jpg",
    category: "Team",
    title: "Operational Workforce Excellence",
    description: "400+ trained professionals delivering consistent fleet maintenance at scale"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_0b1e91d0-9c1d-440a-9b84-aeb555888e53/artifacts/aqoxar6e_12-Feed-D_Soto-Febrero-2026.jpg",
    category: "Team",
    title: "Professional Leadership Team",
    description: "Experienced management overseeing 24/7 corporate operations"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/e41sx32m_5.jpg",
    category: "Team",
    title: "Client Relationship Excellence",
    description: "Dedicated account management ensuring operational consistency"
  },
  // Service Operations
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_dsoto-corporate/artifacts/934n7pub_3.jpg",
    category: "Interior Detailing",
    title: "Premium Interior Operations",
    description: "Systematic interior cleaning protocols for corporate fleet standards"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_3af646f4-3c0e-45dd-86e1-ef70869af78b/artifacts/p99mbmel_10.jpg",
    category: "Interior Detailing",
    title: "Aerial Wash Operations",
    description: "High-efficiency vehicle washing from industrial-grade overhead spray systems"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_3af646f4-3c0e-45dd-86e1-ef70869af78b/artifacts/qbnib32j_13.jpg",
    category: "Fleet Operations",
    title: "Fleet Staging & Processing",
    description: "Large-scale vehicle staging areas designed for rapid fleet turnaround"
  },
  // Exterior Services
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_3af646f4-3c0e-45dd-86e1-ef70869af78b/artifacts/uphlpiqi_11.jpg",
    category: "Exterior Detailing",
    title: "Mass Fleet Exterior Processing",
    description: "Simultaneous multi-vehicle exterior cleaning at enterprise scale"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_3af646f4-3c0e-45dd-86e1-ef70869af78b/artifacts/6ogx6tx2_14.jpg",
    category: "Exterior Detailing",
    title: "Airport Terminal Operations",
    description: "Strategic positioning at major airport transportation hubs for rapid fleet service"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_0b1e91d0-9c1d-440a-9b84-aeb555888e53/artifacts/3q93azq1_Presentacion%20Feed%20Formal.jpg",
    category: "Team",
    title: "Corporate Brand Standards",
    description: "Professional corporate presentation reflecting enterprise-level brand identity"
  }
];

export const categories = ["All", "Fleet Operations", "Interior Detailing", "Exterior Detailing", "Team"];

export const faqData = [
  {
    question: "How does D Soto Cleaning manage high-volume fleet operations?",
    answer: "D Soto Cleaning operates with structured workforce deployment systems, standardized quality protocols, and industrial-grade equipment designed for high-capacity environments. Our 400+ professional team members execute systematic processes ensuring consistent service delivery across airport and hospitality fleet operations 24 hours a day, 7 days a week."
  },
  {
    question: "What industries does D Soto Cleaning serve?",
    answer: "We specialize in serving airport rental car operations, hospitality transportation fleets, corporate vehicle programs, and large-scale commercial transportation providers. Our operational model is engineered specifically for high-volume, quick-turnaround environments requiring enterprise-level consistency and reliability."
  },
  {
    question: "What makes your operational model scalable?",
    answer: "Our scalability stems from documented standard operating procedures, centralized quality management systems, workforce training infrastructure, and proven multi-location operational frameworks. We maintain the ability to expand capacity without compromising service standards through systematic workforce deployment and equipment investment strategies."
  },
  {
    question: "How do you ensure consistent quality control?",
    answer: "Quality assurance is maintained through multi-point vehicle inspection protocols, random quality audits, photographic documentation systems, and performance metrics tracking. Each service delivery undergoes verification before fleet release, ensuring compliance with corporate presentation standards across all operational locations."
  },
  {
    question: "Are your services available 24/7?",
    answer: "Yes. D Soto Cleaning operates 24 hours a day, 7 days a week to support airport and hospitality operations requiring around-the-clock fleet maintenance. Our workforce scheduling systems ensure adequate staffing coverage for all shifts, enabling rapid-response service delivery regardless of demand timing."
  },
  {
    question: "How large is your workforce?",
    answer: "D Soto Cleaning employs over 400 trained professionals across our operational locations. Our workforce undergoes structured training programs, safety certification, and ongoing performance assessment to maintain the operational discipline required for enterprise-level fleet service delivery."
  },
  {
    question: "What safety protocols are implemented?",
    answer: "Our safety framework includes training aligned with OSHA standards, personal protective equipment requirements, chemical handling protocols, ergonomic work practices, and regular safety audits. All team members complete comprehensive safety orientation and ongoing refresher training to maintain zero-incident operational environments."
  },
  {
    question: "Do you operate in airport environments?",
    answer: "Yes. Airport operations constitute a core component of our service portfolio. We maintain the security clearances, insurance requirements, operational protocols, and rapid-response capabilities necessary for seamless integration with airport rental car and ground transportation fleet operations."
  },
  {
    question: "How do you handle quick turnaround demands?",
    answer: "Quick turnaround execution is enabled through optimized workflow systems, pre-positioned equipment and materials, trained personnel deployment, and real-time capacity management. Our operational model is specifically structured to process high vehicle volumes during peak demand periods without compromising communication, quality control, or service consistency."
  },
  {
    question: "What differentiates D Soto Cleaning from traditional detailing companies?",
    answer: "D Soto Cleaning operates as an infrastructure-level corporation, not a traditional detailing service. We provide enterprise fleet maintenance through documented systems, a complete service process, multi-location operational capabilities, and 24/7 availability. What sets us apart is our structured communication with clients at every stage, our quality-focused personnel overseeing vehicle standards throughout the process, and our ability to deliver scalable, accountable, and highly coordinated fleet operations support."
  }
];
